<script setup lang="ts">
import {
  formatTimeFromSeconds,
  convertSecondsFromStringTime,
} from "@/services/functions";
import { computed } from "vue";
import DeliveryPlanType from "@/types/DeliveryPlan"

const props = defineProps<{
  detailDataRef: DeliveryPlanType[];
  boundTimeByHours: string;
  boundTimeByDays: string;
}>();

const monthlyTrips = computed(() => {
  const trips = [];
  const cp = JSON.parse(JSON.stringify(props.detailDataRef));
  cp.forEach((detailData) => {
    (detailData.trips ?? []).forEach((trip) => {
      trips.push(trip);
    });
  });
  return trips;
});

const summary = (key) => {
  let sum = 0;
  monthlyTrips.value.forEach((trip) => {
    sum += trip[key];
  });
  return sum;
};

const workingDays = computed(() => {
  return props.detailDataRef.filter((detailData) => {
    return detailData.trips.length
  }).length
});

const average = computed(() => {
  const totalByTrip = summary("total_by_trip") - summary("leaving_diff_time")
  return formatTimeFromSeconds(totalByTrip / workingDays.value);
});

const boundTimeColor = () => {
  if (!average.value || !props.boundTimeByHours) return "black";
  if (props.boundTimeByHours == "0") return "black";

  const averageSeconds = convertSecondsFromStringTime(average.value);
  const boundTimeByHoursSeconds = convertSecondsFromStringTime(
    props.boundTimeByHours
  );

  return averageSeconds > boundTimeByHoursSeconds ? "red" : "black";
};

const boundDayColor = () => {
  if (!workingDays.value || !props.boundTimeByDays) return "black";
  if (props.boundTimeByDays == "0") return "black";

  return Number(workingDays.value) > Number(props.boundTimeByDays)
    ? "red"
    : "black";
};
</script>

<template>
  <tr>
    <td :style="'color:' + boundTimeColor()">
      {{ average }} / {{ props.boundTimeByHours }}
    </td>
    <td :style="'color:' + boundDayColor()">
      {{ workingDays }} / {{ props.boundTimeByDays }}
    </td>
  </tr>
</template>

<style scoped>
.summary-times-container td {
  padding: 7px;
  text-align: center;
  font-weight: bold !important;
  border: 1 !important;
  border-width: 2px !important;
}
.summary-times-container .table-header {
  background-color: silver !important;
}
.summary-times-container tr {
  line-height: 15px;
  font-size: 13px;
}
</style>
